import {html, css, LitElement, ref, createRef, svg } from 'lit'


let icons = {}

icons["search.default"] = svg`
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5625 0.276367C8.28641 0.276367 9.93971 0.961186 11.1587 2.18017C12.3777 3.39916 13.0625 5.05246 13.0625 6.77637C13.0625 8.38637 12.4725 9.86637 11.5025 11.0064L11.7725 11.2764H12.5625L17.5625 16.2764L16.0625 17.7764L11.0625 12.7764V11.9864L10.7925 11.7164C9.6525 12.6864 8.1725 13.2764 6.5625 13.2764C4.83859 13.2764 3.18529 12.5915 1.96631 11.3726C0.747319 10.1536 0.0625 8.50027 0.0625 6.77637C0.0625 5.05246 0.747319 3.39916 1.96631 2.18017C3.18529 0.961186 4.83859 0.276367 6.5625 0.276367ZM6.5625 2.27637C4.0625 2.27637 2.0625 4.27637 2.0625 6.77637C2.0625 9.27637 4.0625 11.2764 6.5625 11.2764C9.0625 11.2764 11.0625 9.27637 11.0625 6.77637C11.0625 4.27637 9.0625 2.27637 6.5625 2.27637Z" fill="black"/>
    </svg>
`

icons["search.back"] = svg`
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.3973 9.4489L5.44677 10.4984L8.11881 7.82632L10.7909 10.4984L11.8403 9.4489L9.16828 6.77686L11.8403 4.10481L10.7909 3.05534L8.11881 5.72739L5.44677 3.05534L4.3973 4.10481L7.06935 6.77686L4.3973 9.4489ZM2.16439 0.078125C1.76958 0.078125 1.39095 0.23496 1.11178 0.514128C0.832616 0.793296 0.675781 1.17193 0.675781 1.56673V11.987C0.675781 12.3818 0.832616 12.7604 1.11178 13.0396C1.39095 13.3188 1.76958 13.4756 2.16439 13.4756H13.3289C13.8425 13.4756 14.2444 13.2076 14.5124 12.8132L18.5391 6.77686L14.5124 0.733112C14.2444 0.338631 13.8425 0.078125 13.3289 0.078125H2.16439ZM2.16439 1.56673H13.3289L16.8421 6.77686L13.3289 11.987H2.16439V1.56673Z" fill="black"/>
    </svg>
`

icons["search.action"] = svg`
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8516 11.0264H5.85156V16.0264H10.8516V18.0264H3.85156V8.02637H5.85156V9.02637H10.8516V11.0264ZM6.85156 2.02637V4.02637H2.85156V2.02637H6.85156ZM8.85156 0.0263672H0.851562V6.02637H8.85156V0.0263672ZM18.8516 9.02637V11.0264H14.8516V9.02637H18.8516ZM20.8516 7.02637H12.8516V13.0264H20.8516V7.02637ZM18.8516 16.0264V18.0264H14.8516V16.0264H18.8516ZM20.8516 14.0264H12.8516V20.0264H20.8516V14.0264Z" fill="black"/>
    </svg>
`

icons["tree.search.default"] = icons["search.default"] 
icons["tree.search.back"] = icons["search.back"]

icons["user.search.default"] = icons["search.default"] 
icons["user.search.back"] = icons["search.back"]


icons["tree.search.action"] = svg`
<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.73344 7.77637L14.2734 13.3164V14.7764H12.8134L7.27344 9.23637L1.73344 14.7764H0.273438V13.3164L5.81344 7.77637L0.273438 2.23637V0.776367H1.73344L7.27344 6.31637L12.8134 0.776367H14.2734V2.23637L8.73344 7.77637Z" fill="#434343"/>
</svg>
`

icons["user.search.action"] = icons["tree.search.action"]


export class MobileSearchbar extends LitElement {

    static get properties() {
        return {
          namespace:  { type: String },
          action:     { type: String },
          immediate:  { type: Boolean }
        }
    }

    $input = createRef()
    $icon  = createRef()

    constructor() {
        super()
        this.immediate = false
    }

    connectedCallback() {
        super.connectedCallback()
    }

    render() {
        return html`
            <div class="icon" part="icon" ${ref(this.$icon)}></div>
            <input type="text" @input=${this.engage} @change=${this.search} ${ref(this.$input)}>
            <button part="button" class="tree" @click=${() => { this.immediate && this.reset(); this.broadcast(this.action)}}>${icons[`${this.namespace}.action`]}</button>
        `
    }

    firstUpdated() {
        render(icons[`${this.namespace}.default`], this.$icon.value)
    }


    engage() {
        if (this.$input.value.value.length > 0) {
            if (this.immediate) {
                this.search()
            }
            render(html`<span @click=${this.reset.bind(this)}>${icons[`${this.namespace}.back`]}</span>`, this.$icon.value)
        } else {
            render(icons[`${this.namespace}.default`], this.$icon.value)
        }
    }


    search() {  
        if (this.$input.value.value.length > 0) {
            this.broadcast(`${this.namespace}.make`, this.$input.value.value)
        } else {
            this.broadcast(`${this.namespace}.undo`)
        }
    }

    reset() {
        this.$input.value.value = ""
        this.broadcast(`${this.namespace}.undo`)
        render(icons[`${this.namespace}.default`], this.$icon.value)
    }


    static get styles() {
        return css`
            :host {
                position: relative;
                display: grid;
                grid-template-columns: 1fr 40px;
                gap: 15px;
                align-items: center;
            }

            input,
            button.tree {
                height: 34px;
                appearance: none;
                border: none;
                background: rgba(0, 0, 0, 0.05);
                border-radius: 5px;
            }

            input {
                font-family: "Inter Medium";
                font-size: 13px;
                padding-left: 40px;
            }

            input:focus {
                outline: none;
            }

            .icon {
                position: absolute;
                left: 32px;
            }
        `
    }
}

window.customElements.define('mobile-searchbar', MobileSearchbar)